import { createClient } from '@slerp/client'
import { Availabilities } from './../Form'
import {
  UPDATE_MODIFIER,
  UPDATE_MODIFIER_SKU_AND_SOURCE_ID
} from './../ModifierQueries'

interface UpdateModifierProps {
  modifierId: string
  name: string
  sku: string | null
  sourceId?: string
  price: number
  vat: number
  alcoholic: boolean
  published: boolean
  modifierGroups: string[]
  restrictionsId: string
  calorieData?: {
    id: string
    caloriesPerServing: number
    amountPerServing: number
    servingUnit: string
  } | null
  allergens: string[] | null
  availabilities: Availabilities[]
}

const UpdateModifier = async ({
  modifierId,
  name,
  sku,
  sourceId,
  price,
  vat,
  alcoholic,
  published,
  restrictionsId,
  modifierGroups,
  calorieData,
  allergens,
  availabilities
}: UpdateModifierProps) => {
  const apiKey = localStorage.getItem('token') || ''
  const client = createClient(apiKey)

  const availabilitiesParams = availabilities.map((availability) => ({
    fulfillmentType: availability.fulfillment_type.toUpperCase(),
    isAvailable: availability.is_available,
    id: availability.id
  }))

  const variables = {
    id: modifierId,
    name,
    sku,
    price,
    vat,
    restrictions: { id: restrictionsId, alcoholic },
    modifierGroups: modifierGroups,
    isPublished: published,
    calorieData,
    allergens,
    availabilities: availabilitiesParams
  }

  const skuVariables = {
    id: modifierId,
    sku,
    sourceId
  }

  return Promise.all([
    client.mutate({
      mutation: UPDATE_MODIFIER,
      variables
    }),
    client.mutate({
      mutation: UPDATE_MODIFIER_SKU_AND_SOURCE_ID,
      variables: skuVariables
    })
  ])
}

export default UpdateModifier
